import { motion } from 'framer-motion'
import { useInView } from 'framer-motion'
import { useRef } from 'react'
import { 
  SiReact, 
  SiJavascript, 
  SiTypescript, 
  SiFirebase,
  SiGit,
  SiRedux,
  SiExpo,
  SiGoogle
} from 'react-icons/si'
import { FiMap, FiCreditCard, FiZap } from 'react-icons/fi'
import './Skills.css'

const Skills = () => {
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true, margin: "-100px" })

  const skills = [
    { name: 'React Native', icon: SiReact },
    { name: 'JavaScript', icon: SiJavascript },
    { name: 'TypeScript', icon: SiTypescript },
    { name: 'React', icon: SiReact },
    { name: 'Firebase', icon: SiFirebase },
    { name: 'Redux', icon: SiRedux },
    { name: 'Expo', icon: SiExpo },
    { name: 'Git', icon: SiGit },
    { name: 'AdMob', icon: SiGoogle },
    { name: 'Maps & Geo', icon: FiMap },
    { name: 'Payments / Subscriptions', icon: FiCreditCard },
    { name: 'Animations', icon: FiZap },
  ]

  return (
    <section id="skills" className="skills" ref={ref}>
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="section-header"
        >
          <h2 className="section-title">
            My <span className="gradient-text">Skills</span>
          </h2>
          <p className="section-subtitle">
            Technologies and tools I work with
          </p>
        </motion.div>

        <div className="skills-grid">
          {skills.map((skill, index) => {
            const Icon = skill.icon
            return (
              <motion.div
                key={skill.name}
                initial={{ opacity: 0, scale: 0.5 }}
                animate={isInView ? { opacity: 1, scale: 1 } : {}}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="skill-card"
                whileHover={{ scale: 1.05, y: -5 }}
              >
                <div className="skill-icon">
                  <Icon />
                </div>
                <h3>{skill.name}</h3>
              </motion.div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default Skills

